import {MakeElParams} from '../interfaces/misc';

export function mkEl(tag: string, params?: MakeElParams): HTMLElement {
    let el: any = document.createElement(tag);
    try {
        if (params?.text) {
            el.innerText = params.text;
        }

        if (params?.html) {
            el.innerHTML = params.html;
        }

        if (params?.htmlFor) {
            el.htmlFor = params.htmlFor;
        }

        if (params?.data?.length) {
            params.data.forEach((d) => {
                el.dataset[d.name] = d.val.toString();
            })
        }

        if (params?.style?.length) {
            params.style.forEach((s: any) => {
                el.style[s.name] = s.val;
            })
        }

        if (params?.name) {
            el.name = params.name;
        }

        if (params?.target) {
            el.target = params.target;
        }

        if (params?.href) {
            el.href = params.href;
        }

        if (params?.src) {
            el.src = params.src;
        }

        if (params?.srcset) {
            el.srcset = params.srcset;
        }

        if (params?.title) {
            el.title = params.title;
        }

        if (params?.alt) {
            el.alt = params.alt;
        }

        if (params?.type && tag !== 'textarea') {
            el.type = params.type;
        }

        if (params?.id) {
            el.id = params.id;
        }

        if (params?.for) {
            el.htmlFor = params.for;
        }

        if (params?.value) {
            el.value = params.value;
        }

        if (params?.disabled) {
            el.disabled = params.disabled;
        }

        if (params?.class) {
            (el as HTMLElement).classList.add(...params.class);
        }

        if (params?.append?.length) {
            (el as HTMLElement).append(...params.append);
        }

        if (params?.click && typeof params?.click === 'function') {
            el.addEventListener('click', params.click);
        }
    } catch (e) {
        console.error(e, params);
    }

    return el;
}

export function getIcon(type: string) {
    let ico = '';
    switch (type) {
        case 'external':
            ico = '<i class="fa fa-external-link" aria-hidden="true"></i>';
            break;
        case 'info':
            ico = '<i class="fa fa-info-circle" aria-hidden="true"></i>';
            break;
        case 'alert':
        case 'warning':
            ico = '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>';
            break;
        case 'video':
            ico = '<i class="fa fa-video-camera" aria-hidden="true"></i>';
            break;
        case 'envelope':
            ico = '<i class="fa fa-envelope" aria-hidden="true"></i>';
            break;
        case 'envelope2':
            ico = '<i class="sta-icon envelope" aria-hidden="true"></i>';
            break;
        case 'download':
            ico = '<i class="fa fa-download" aria-hidden="true"></i>';
            break;
        case 'menu':
            ico = '<i class="fa fa-bars" aria-hidden="true"></i>';
            break;
        case 'delete':
            ico = '<i class="fa fa-trash" aria-hidden="true"></i>';
            break;
        case 'sync':
            ico = '<i class="fa fa-refresh" aria-hidden="true"></i>';
            break;
        case 'repeat':
            ico = '<i class="fa fa-repeat" aria-hidden="true"></i>';
            break;
        case 'save':
            ico = '<i class="fa fa-floppy-o" aria-hidden="true"></i>';
            break;
        case 'hb':
            ico = '<i class="fa fa-heartbeat" aria-hidden="true"></i>\n';
            break;
        case 'user':
            ico = '<i class="fa fa-user-plus" aria-hidden="true"></i>\n';
            break;
        case 'eur':
            ico = '<i class="fa fa-eur" aria-hidden="true"></i>\n';
            break;
        case 'left':
            ico = '<i class="fas fa-chevron-left"></i>\n';
            break;
        case 'right':
            ico = '<i class="fas fa-chevron-right"></i>\n';
            break;
        case 'edit':
            ico = '<i class="fa fa-pencil" aria-hidden="true"></i>';
            break;
        case 'times':
            ico = '<i class="fa fa-times" aria-hidden="true"></i>';
            break;
        case 'users':
            ico = '<i class="fa fa-user-plus" aria-hidden="true"></i>';
            break;
        case 'calendar':
            ico = '<i class="fa fa-calendar-check-o" aria-hidden="true"></i>';
            break;
        case 'code':
            ico = '<i class="fa fa-code" aria-hidden="true"></i>';
            break;
        case 'certificate':
            ico = '<i class="fa fa-certificate" aria-hidden="true"></i>\n';
            break;
    }

    return ico;
}

export function confirmPin() {
    let input = prompt("Bitte geben Sie einen Sicherheits-Pin ein", "");
    let pin = parseInt(input, 10);
    return pin === 3311;
}